export default "__VITE_ASSET__mFOmEniMfH$sf9EazgpDQQ__"